import { Tabs } from '@mantine/core';
import cs from 'classnames';
import { groupBy } from 'lodash';
import type { FC } from 'react';
import { useMemo, useState } from 'react';
import { Container } from '@/DesignSystem/Component';
import { useAppSelector } from '@/Module/Store/Hook';
import SubscriptionInoPlan from '@/Module/Subscription/Component/SubscriptionInoPage/SubscriptionInoPlan';
import styles from '@/Module/Subscription/Component/SubscriptionInoPage/subscriptionInoTab.module.scss';
import { selectedSubscriptionPlanActiveSelector } from '@/Module/Subscription/Store/Selector/selectedSubscriptionPlanActiveSelector';
const LABELS: Record<number, {
  title: string;
  value: string;
}> = {
  150: {
    title: 'ماهانه',
    value: 'month'
  },
  200: {
    title: 'سالانه',
    value: 'year'
  }
};
const SubscriptionInoTab: FC = () => {
  const planList = useAppSelector(selectedSubscriptionPlanActiveSelector);
  const data = useMemo(() => {
    return Object.entries(groupBy(planList, 'sortOrder')).map(([sortOrder, groupList]) => ({
      sortOrder: Number(sortOrder),
      items: groupList
    })).sort((a, b) => b.sortOrder - a.sortOrder);
  }, [planList]);
  const [activeTab, setActiveTab] = useState<string | null>(() => {
    const defaultSortOrder = planList?.[0]?.sortOrder;
    return LABELS[defaultSortOrder]?.value ?? null;
  });
  return <div className="bg-[#EBEEF0] py-6 sm:py-12" id="subscription" data-sentry-component="SubscriptionInoTab" data-sentry-source-file="SubscriptionInoTab.tsx">
      <Container className="relative max-w-[900px]" data-sentry-element="Container" data-sentry-source-file="SubscriptionInoTab.tsx">
        <div className="text-center md:mt-8">
          <h1 className="mb-1 text-xl  font-extrabold text-blackFive sm:text-4xl">
            اشتراک <span className="text-blueFour">آی‌نو</span> برای موفقیت در امتحان‌ها
          </h1>
          <p className="sm:text-md mt-2 text-sm font-semibold text-blackThree">
            یادگیری آنلاین برای همه آسان و مقرون‌به‌صرفه!
          </p>
        </div>
        <Tabs unstyled defaultValue={activeTab} value={activeTab} onChange={setActiveTab} classNames={{
        root: 'flex flex-col  mt-10 sm:mt-12 relative',
        list: 'flex text-center mx-auto flex-wrap rounded-full p-2 bg-white',
        panel: 'mx-auto w-full',
        tab: 'flex-1 relative flex items-center rounded-full font-bold justify-center px-4 sm:px-6 py-2 text-[12px] sm:text-base transition-all duration-200 ease-in-out disabled:cursor-not-allowed disabled:text-gray-400'
      }} data-sentry-element="Tabs" data-sentry-source-file="SubscriptionInoTab.tsx">
          <Tabs.List data-sentry-element="unknown" data-sentry-source-file="SubscriptionInoTab.tsx">
            {data.map(({
            sortOrder
          }) => <Tabs.Tab key={sortOrder} value={LABELS[sortOrder]?.value} classNames={{
            tab: styles.tab
          }}>
                {sortOrder === 200 && <div className="absolute right-[-45px] top-[-45px] rounded-full bg-orangeFour px-4 py-1 text-sm !text-white shadow-md shadow-blackThree before:absolute before:bottom-[-10px] before:left-4  before:border-x-[8px]  before:border-t-[10px]
                  before:border-x-transparent before:border-t-orangeFour sm:py-2 sm:text-base">
                    80 % ارزان‌تر
                  </div>}
                {LABELS[sortOrder]?.title}
              </Tabs.Tab>)}
          </Tabs.List>

          {activeTab === 'year' && <div className="mt-4 text-center text-sm font-semibold text-blackThree sm:block">
              <span> اشتراک سالیانه، تا </span>
              <span className="text-blueFour">شروع سال تحصیلی جدید </span>
              <span> فعال خواهد بود.</span>
            </div>}
          {data.map(({
          sortOrder,
          items
        }) => <Tabs.Panel key={sortOrder} value={LABELS[sortOrder]?.value} className={cs('grid flex-row grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6 px-4 py-6 sm:p-6 md:pt-10 sm:mt-4')}>
              {items.map(plan => <div className="sm:mt-[52px]" key={plan.id}>
                  <SubscriptionInoPlan {...plan} />
                </div>)}
            </Tabs.Panel>)}
        </Tabs>
      </Container>
    </div>;
};
export default SubscriptionInoTab;